<template>
  <div class="ecology-main" v-loading="loading">
    <div class="content" v-if="!loading">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
// 生态服务窗口
export default {
  computed: {
    userId() {
      return this.$store.state.user.userId;
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
    this.checkLoading();
  },
  methods: {
    checkLoading() {
      console.log("checkLoading");
      if (
        !this.$store.state.ecology.userInfo ||
        !this.$store.state.ecology.userInfo.userType
      ) {
        setTimeout(() => {
          this.checkLoading();
        }, 300);
        return;
      } else {
        const userType = this.$store.state.ecology.userInfo.userType;
        if (![1, 2].includes(+userType)) {
          this.$router.push({ name: "main" });
        } else {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ecology-main {
  display: flex;
  justify-content: center;
}

.content {
  width: 1200px;
}
</style>
<style lang="scss">
.ecology-main {
  font-family: Alibaba PuHuiTi !important;

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: Alibaba PuHuiTi !important;
  }

  .el-link {
    color: #2a54d1;

  }

  .el-link.is-underline:hover:after {
    border-bottom: none;
  }

  .path {
    height: 36px;
    line-height: 36px;

    .normal {
      font-family: Alibaba PuHuiTi;
      font-size: 14px;
      color: #999999;
    }

    .active {
      font-family: Alibaba PuHuiTi;
      font-size: 14px;
      font-weight: 600;
      color: #333333;
    }

    .space {
      margin-right: 8px;
      margin-left: 8px;
    }
  }
}

.pointer {
  cursor: pointer;
}
</style>
